import { Collapse, Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import type { FC, JSX, PropsWithChildren } from "react";
import { useState } from "react";

type Props = {
	label: string;
	value?: string;
	defaultExpanded?: boolean;
};

export const DetailRowCollapsible: FC<PropsWithChildren<Props>> = ({
	label,
	value,
	defaultExpanded = false,
	children,
}): JSX.Element => {
	const theme = useTheme();
	const [expanded, setExpanded] = useState(defaultExpanded);

	return (
		<Stack py={theme.spacingTokens.xs}>
			<Stack
				onClick={() => setExpanded((prev) => !prev)}
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				px={theme.spacingTokens.lg}
				sx={{ cursor: "pointer" }}
			>
				<Typography variant="bodyStrong">{label}</Typography>
				<Stack direction="row" alignItems="center" gap={theme.spacingTokens.xs}>
					{value && (
						<Typography variant="bodyStrong" tabular>
							{value}
						</Typography>
					)}
					{expanded ? (
						<ChevronUp
							size={theme.iconSize.sm}
							color={theme.palette.primary.main}
						/>
					) : (
						<ChevronDown
							size={theme.iconSize.sm}
							color={theme.palette.primary.main}
						/>
					)}
				</Stack>
			</Stack>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<Stack pt={theme.spacingTokens.xs}>{children}</Stack>
			</Collapse>
		</Stack>
	);
};
